export const ROUTER_INDEX = '/'
export const ROUTER_WELCOME = '/welcome'
export const ROUTER_LANDING = '/landing'
export const ROUTER_CANVOPIX = '/canvopix'
// export const ROUTER_WORKSPACE = '/workspace'
export const ROUTER_INDEX_PAGE = '/'
export const ROUTER_INVITE = '/invite'
export const ROUTER_INVITE_CENTER = '/invite-center'
export const ROUTER_AI_TOOLS = '/tools'

export const ROUTER_CUTOUT = '/tools/cutout'
export const ROUTER_COMPRESS = '/tools/compress'
export const ROUTER_CLEARER = '/tools/clearer' // 变清晰
export const ROUTER_CLIP = '/tools/clip' // 图片裁剪


export const ROUTER_DIAGRAMS = '/diagrams'
export const ROUTER_HISTORY = '/history'
export const ROUTER_FAVORITE = '/favorite'
export const ROUTER_TRASH = '/trash'

export const ROUTER_TEMPLATE_LIST = '/templates'
export const ROUTER_TEMPLATE_VIEW = '/templates/:id'
export const ROUTER_TEMPLATE_EDIT = '/templates/edit/:id'
export function GEN_ROUTER_TEMPLATE_VIEW(id) {
  return `/templates/${id}`
}

export function GEN_ROUTER_TEMPLATE_EDIT(id) {
  return `/templates/edit/${id}`
}


export const ROUTER_LABEL_EDITOR = '/label/d'
export const ROUTER_LABEL_EDITOR_DEFAULT = '/label/default'
export const ROUTER_FABRA_EDITOR = '/editor'

export const ROUTER_TERMS_PRIVACY_POLICY = '/privacy_policy'
export const ROUTER_TERMS_SERVICE = '/terms_of_service'
export const ROUTER_ABOUT_US = '/about_us'
export const ROUTER_SETTING = '/setting'

export const ROUTER_AUTHORIZE_PAGE = '/only_authorize'


// cn only
export const ROUTER_LOGIN = '/login'

// international only
export const ROUTER_BETTER_AUTH = '/unified_auth'
